import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

import {
    setUsers as setUsersAction,
    setSystems as setSystemsAction,
    // setSystemsExtended as setSystemsExtendedAction,
    setMatrixHeaders as setMatrixHeadersAction,
    setRisks as setRisksAction,
    setRiskLevels as setRiskLevelsAction,
    setParametersOpen as setParametersOpenAction,
    initModelingManual,
} from "../../../reducers/reports-modeling/userLevelSlice";

import { getFieldValidationError } from "../../../utils/sodReports";

import useReduxValue from "../../common/hooks/useReduxValue";

import { MatrixIdsInput, RiskIdsInput, RiskLevelInput, UsersInput, SystemIdsInput } from "../../sod-reports/report-parameters";

import ReportModelingParameters from "../report-modeling-parameters";
import { reportsService } from "../../../services/reports-service";
import { useNavigate } from "react-router-dom";

const getSystems = (params, signal) => {
    return reportsService.getSystemsForSimulationSearchHelp(params, signal);
};

const getEmployees = (params, signal) => {
    return reportsService.getEmployeesForSimulationSearchHelp(params, signal);
};

const UserLevelModelingParameters = ({ onShowVariantsClick }) => {
    const intl = useIntl();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const currentVariant = useSelector((state) => state.reportsModeling.userLevel.currentVariant);
    const validationErrors = useSelector((state) => state.reportsModeling.userLevel.validationErrors);

    const [users, setUsers] = useReduxValue((state) => state.reportsModeling.userLevel.parameters.users, setUsersAction);
    //const [systems, setSystems] = useReduxValue(state => state.reportsModeling.userLevel.systems, setSystemsAction);
    const [systems, setSystems] = useReduxValue((state) => state.reportsModeling.userLevel.parameters.systems, setSystemsAction);
    const [matrixHeaders, setMatrixHeaders] = useReduxValue(
        (state) => state.reportsModeling.userLevel.parameters.matrixHeaders,
        setMatrixHeadersAction
    );
    const [risks, setRisks] = useReduxValue((state) => state.reportsModeling.userLevel.parameters.risks, setRisksAction);
    const [riskLevels, setRiskLevels] = useReduxValue((state) => state.reportsModeling.userLevel.parameters.riskLevels, setRiskLevelsAction);
    const [open, setOpen] = useReduxValue((state) => state.reportsModeling.userLevel.parametersOpen, setParametersOpenAction);

    const titles = [intl.formatMessage({ id: "user-level-report-page.title" })];

    if (currentVariant) {
        titles.push(intl.formatMessage({ id: "user-level-report-page.variant-selected.title" }, { name: currentVariant.name }));
    }

    const handleOpenClick = (event) => {
        event.stopPropagation();
        setOpen(!open);
    };

    const handleApply = async () => {
        await dispatch(initModelingManual()).unwrap();
        navigate("/modeling-user-level");
    };

    const applyBtnDisabled = users?.length && systems.length == 1;

    return (
        <ReportModelingParameters
            title={titles.join(" ")}
            open={open}
            applyDisabled={!applyBtnDisabled}
            onOpenClick={handleOpenClick}
            onShowVariantsClick={onShowVariantsClick}
            onApplyClick={handleApply}
        >
            <UsersInput
                ids={users}
                setIds={setUsers}
                error={getFieldValidationError(validationErrors, "usernames")}
                disabledMultiple={true}
                getUsers={getEmployees}
            />

            <SystemIdsInput tags={systems} setTags={setSystems} getSystems={getSystems} disabledMultiple={true} />

            <MatrixIdsInput tags={matrixHeaders} setTags={setMatrixHeaders} />

            <RiskIdsInput tags={risks} setTags={setRisks} />

            <RiskLevelInput tags={riskLevels} setTags={setRiskLevels} />
        </ReportModelingParameters>
    );
};

UserLevelModelingParameters.propTypes = {
    onShowVariantsClick: PropTypes.func,
};

export default UserLevelModelingParameters;
